import React, { useEffect } from 'react'
import { withParsedContext } from '../../Magazines/withJSSContext'
import { ApplicationInsights, ITelemetryPlugin } from '@microsoft/applicationinsights-web'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'

interface Props {
  pageEditing: boolean

  parsedFields: {
    ApplicationInsightsInstrumentationKey: string
  }
}

const ApplicationInsightsScripts: React.FC<Props> = ({ parsedFields, pageEditing }) => {
  const instrumentationKey = parsedFields?.ApplicationInsightsInstrumentationKey

  useEffect(() => {
    if (!pageEditing) {
      const reactPlugin = new ReactPlugin() as unknown as ITelemetryPlugin
      const appInsights = new ApplicationInsights({
        config: {
          instrumentationKey,
          extensions: [reactPlugin],
          disableFetchTracking: false,
          disablePageUnloadEvents: ['unload'],
          extensionConfig: {
            ApplicationInsightsAnalytics: {
              disablePageUnloadEvents: ['unload'],
            },
          },
        },
      })

      appInsights.loadAppInsights()
    }
  }, [instrumentationKey, pageEditing])

  return null
}

export default withParsedContext(ApplicationInsightsScripts as React.FC)
